module.exports = __webpack_public_path__ + "img/2012-08-18 10.54.07.95046322.jpg";